export default __webpack_public_path__ + "static/platform-tableau-de-bord-projet-7541448eaf4b4318a0f21854f8b4ee04.png";